import * as React from "react";

import "./mailing-assets-route.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";

import {BulkMailPermit}         from "../../common/bulk-mail-permit/bulk-mail-permit";
import {IntelligentMailBarcode} from "../../common/intelligent-mail-barcode/intelligent-mail-barcode";
import {SampleAddressSection}   from "../../common/sample-address/sample-address";
import {AddressBookLayout}      from "../common/address-book-layout";

export const MailingAssetsRoute = ({}) => cs(
    ({}, next) => AddressBookLayout({activeTab: "assets", next}),

    consumeContext("apis"),

    ["sections", ({apis}, next) => cs(        
        ["bulkMailPermit", ({}, next) => BulkMailPermit({
            apis: {
                getIndica: () => apis.next.bulkMailPermit.getIndica(),
                saveIndicia: ({id, indicia}) => apis.next.bulkMailPermit.saveIndicia({
                    id,
                    indicia,
                }),
            },
            next,
        })],
        ["imb", ({}, next) => IntelligentMailBarcode({next})],
        ["sampleAddress", ({}, next) => SampleAddressSection({next})],
        ({bulkMailPermit, imb, sampleAddress}) => next([bulkMailPermit, imb, sampleAddress]),
    )],

    ({sections}) => (
        <div className="mailing-assets-route-3t7">
            {(sections.find((section) => section?.loading)) && (
                <div className="loading" xd-qa-type="label" xd-qa-name="loading">
                    <i className="fa fa-spinner fa-pulse"/>
                    Loading...
                </div>
            )}
            {sections.map((section, i) => section?.render && cs(
                keyed(i),
                ["content", (_, next) => section.render({next})],
                ({content}) => Section(content),
            ))}
        </div>
    )
);

const Section = ({header, content}) => (
    <div className="section">
        <div className="header">
            <div className="title" xd-qa-type="label" xd-qa-name={header.title}>
                {header.title}
            </div>

            <a {...{
                className: "edit",
                onClick: () => header.action.onClick(),
                "xd-qa-type": "link",
                "xd-qa-name": header.action.xdQaName,
            }}>
                {header.action.label}
            </a>
        </div>

        {header.subtitle && (
            <div className="subtitle" xd-qa-type="label" xd-qa-name={header.subtitle}>
                {header.subtitle}
            </div>
        )}

        {content}
    </div>
);
